import React from 'react'
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

const SpinnerComponent = ({loading}) => {
  return (
    <>
      {
        loading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className='spinner'
      />
      }
    </>
  )
}

SpinnerComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
};
export default SpinnerComponent
